// @flow

import { Map as ImmutableMap } from 'immutable';
import {
  CENTER_MAP,
  SET_EXTENT,
  CHANGE_ROTATION,
  START_DRAWING_FLIGHT,
  CANCEL_DRAWING_FLIGHT,
  FINISH_DRAWING_FLIGHT,
  SET_OLLAYERS,
  GET_LAYERS_CONFIG_SUCCESS,
  SET_DRONE_LOCATION,
  SET_LABELS_CONFIG,
  SET_EDIT_MODE,
  GET_BOX_EXTENT,
  BOX_EXTENT,
  MAP_MODE,
} from './../types/map';
import type { MapAction } from './../actions/map';
import type { Map } from 'ol/map';
import { getSelectInteractionManager } from './../utilities/selectInteractionManager';

import {
  SIGN_OUT,
} from './../types/auth';

const loadedConfig = JSON.parse(localStorage.getItem('labelsConfig'));

const INITIAL_STATE = ImmutableMap({
  droneLocation: undefined,  
  center: [2257999, 6447111],
  extent: undefined,
  rotation: 0,
  drawingFlight: undefined,
  olLayers: undefined,
  layersConfig: undefined,
  labelsConfig: loadedConfig && loadedConfig.layerName !== '' ? [loadedConfig] : [],
  editMode: false,
});

const MapDataReducer = (state: ImmutableMap<string, string | Map | number | boolean> = INITIAL_STATE, action: MapAction) => {
  switch (action.type) {

    case SET_DRONE_LOCATION:
      const { droneLocation } = action;
      return state
        .set('droneLocation', droneLocation);

    case CENTER_MAP:
      return state
        .set('center', action.center)
        .set('extent', undefined);

    case SET_EXTENT:
      return state
        .set('center', undefined)
        .set('extent', action.extent);

    case CHANGE_ROTATION:
      return state
        .set('rotation', action.rotation);

    case START_DRAWING_FLIGHT:
      return state
        .set('drawingFlight', action.flight);

    case CANCEL_DRAWING_FLIGHT:
      return state
        .set('drawingFlight', 'canceled');

    case FINISH_DRAWING_FLIGHT:
      return state
        .set('drawingFlight', 'finished');

    case SET_OLLAYERS:
      return state
        .set('olLayers', action.olLayers);

    case GET_LAYERS_CONFIG_SUCCESS:
      return state
        .set('layersConfig', action.layersConfig);

    case SET_LABELS_CONFIG:
      return state
        .set('labelsConfig', action.labelsConfig);

    case SIGN_OUT:
      return INITIAL_STATE;

    case SET_EDIT_MODE:
        if (action.editMode) {
            getSelectInteractionManager('map').disableSelectInteraction();
        } else {
            getSelectInteractionManager('map').enableSelectInteraction();
        }

      return state
        .set('editMode', action.editMode)
        .set(MAP_MODE, action[MAP_MODE]);
      
    case GET_BOX_EXTENT:
      return state
        .set(BOX_EXTENT, action[BOX_EXTENT]);

    default:
      return state;
  }
};

export default MapDataReducer;


// WEBPACK FOOTER //
// ./src/reducers/mapData.jsx